import "./styles.css";
import "./base.css";
import { useEffect, useState } from "react";

/* PopUp import */
import Header from "./Header";
import Home from "./Home/Home";
import { ConsContextProvider } from "./context/ConsContext";

/* Router */
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Send from "./Send";
import WhatsApp from "./WhatsApp/WhatsApp";

export default function App() {
  return (
    <div className="App">
      <ConsContextProvider>
        <BrowserRouter basename="/cotizador">
          <ScrollToTop />
          <Header />
          {/* Routes */}
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/send" element={<Send />} />
            {/* Page Not Found */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          {/* End Routes */}
        </BrowserRouter>
        <WhatsApp phone="5491131645366?text=Ver%20Precios%20y%20Cuotas%20Toyota%20Plan" />
      </ConsContextProvider>
    </div>
  );
}
